const styles = theme => ({
  box: {
    margin: 15,
    width: "calc(100% / 3 - 30px)",
    padding: 10,
    transition: ".3s",
    boxShadow: "0 3px 6px rgba(0, 0, 0, .16)",
    border: "1px solid #e1e1e1",
    borderRadius: 3,
    paddingRight: 0,

    "&:hover": {
      boxShadow: "0 3px 20px rgba(0, 0, 0, .5)",
      transform: "translateY(-5px)",

      "& > div > a.link-icon": {
        background: theme.colors.primary,
        color: "white",
        boxShadow: "0 3px 10px rgba(42,193,127, 0.5)"
      }
    }
  },
  boxImg: {
    height: 400,
    overflow: "overlay",
    marginBottom: 20
  },
  img: {
    width: "100%",
    maxHeight: "initial",
    objectFit: 'cover'
  },
  boxDetail: {
    display: "flex",
    alignItems: "center",
    marginRight: 10,

    "& > div": {
      width: "calc(100% - 50px)",
      marginRight: 10,

      "& h6": {
        marginBottom: 5,

        "& a": {
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: 1,
          WebkitBoxOrient: "vertical",
          textTransform: 'uppercase',
          fontWeight: 'bold',
        },

        "&:hover": {
          color: theme.colors.primary
        }
      },

      "& h5 a": {
        color: theme.colors.primary,
        overflow: "hidden",
        display: "-webkit-box",
        WebkitLineClamp: 1,
        WebkitBoxOrient: "vertical",

        "&:hover": {
          filter: "brightness(.7)"
        }
      }
    },

    "& > button": {
      width: 40,
      height: 40,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: 5,
      backgroundColor: "#fff",
      border: "1px solid Teal",
      color: "Teal",
      boxShadow: "0px 3px 6px rgba(0, 0, 0, .3)",
      cursor: 'pointer',

      "&:hover": {
        color: theme.colors.primary
      },

      "&:focus": {
        outline: "none"
      }
    }
  },

  // ----------Mobile---------------------

  [theme.breakpoints.down('sm')]: {
    box: {
      margin: "5px",
      width: "calc(100% / 2 - 10px)",
    }
  },

  [theme.breakpoints.down('xs')]: {
    box: {
      width: "100%",
      margin: '5px 15px'
    }
  },
});

export default styles;
